import api from "@/services/api/api-candidates-actions"
import { CMExamConfigApiData } from "../modules/course_managment/classes/CMExamConfig"
import { dateFormating } from "@/util"
import HandleFailedModel from "../modules/candidates/core/models/candidatesHandleFailedModel"

export default class CandidatesActionsService {

  async quickReserve(city, ids, data) {
    try {
      let apiData = {
        ids,
        city,
        location: data.location,
        exam_date: dateFormating(data.date).join('-'),
        exam_time_from: data.timeFrom,
        exam_time_to: data.timeTo,
        is_exchange: data.isExchange,
      }
      let res = await api.quickReserve(apiData)
      return {
        failedCandidates: res.failed_candidates.map(item => new HandleFailedModel(item)),
        error: res.error
      }
    } catch (error) {
      return Promise.reject(error)
    }
  }
}